import { forwardRef } from "react";
import type { SelectOption } from "./Select";
import type { ListPlacement } from "./useListPlacement";

import styles from "./Select.module.css";

interface Props {
  options: SelectOption<string>[];
  value: string;
  placement: ListPlacement;
  // Индекс, а не значение: так Select не теряет тип Value.
  onSelect: (index: number) => void;
}

export const SelectList = forwardRef<HTMLUListElement, Props>(
  ({ options, value, placement, onSelect }, ref) => (
    <ul
      ref={ref}
      className={`${styles.list} ${placement.openUp ? styles.listUp : ""}`}
      style={{ maxHeight: placement.maxHeight }}
      role="listbox"
    >
      {options.map((option, index) => (
        <li
          key={option.value}
          role="option"
          aria-selected={option.value === value}
        >
          <button
            type="button"
            className={`${styles.option} ${option.value === value ? styles.selected : ""}`}
            onClick={() => onSelect(index)}
          >
            {option.label}
          </button>
        </li>
      ))}
    </ul>
  ),
);

SelectList.displayName = "SelectList";
